<ng-container *appUserRoleUp="[ Role.Vendor ]">
    <app-equipment-list-vendor></app-equipment-list-vendor>
</ng-container>

<ng-container *appUserRoleUp="[ Role.Admin, Role.User ]">
    <app-equipment-list-buadmin></app-equipment-list-buadmin>
</ng-container>